module.exports = __webpack_public_path__ + "img/arrow-d-icon.889e92dc.svg";